import { ReactNode } from 'react'
import useTranslation from 'next-translate/useTranslation'
import CloseIcon from '@ancon/wildcat-ui/shared/icons/close.svg'

import HeadingText from '../HeadingText'
import BodyText from '../BodyText'

import styles from './ModalHeader.module.scss'

export type ModalHeaderProps = {
  onClose?: () => void
  title?: string
  titleId?: string
  eyebrow?: ReactNode
  subtitle?: ReactNode
}

export default function ModalHeader({
  title,
  titleId,
  onClose,
  eyebrow,
  subtitle,
}: ModalHeaderProps) {
  const { t } = useTranslation('common')

  const shouldShowHeader = title || onClose || eyebrow || subtitle
  const hasTitleGroup = !!eyebrow || !!subtitle

  const heading = (
    <HeadingText as="h2" id={titleId}>
      {title}
    </HeadingText>
  )

  return (
    shouldShowHeader && (
      <>
        {hasTitleGroup ? (
          <div className={styles.titleGroup}>
            {eyebrow && <div className={styles.eyebrow}>{eyebrow}</div>}
            {heading}
            {subtitle && (
              <BodyText as="p" color="body-1">
                {subtitle}
              </BodyText>
            )}
          </div>
        ) : (
          heading
        )}
        {onClose && (
          <button
            type="button"
            className={styles.closeButton}
            onClick={onClose}
            aria-label={t('close')}
          >
            <CloseIcon aria-hidden />
          </button>
        )}
      </>
    )
  )
}
